<template>
	<div class="body-container" :class="openSelect ? 'modal-open' : ''" @click="closeSelectExpand">
		<checkOutHeader></checkOutHeader>
		<div class="global-header-spacer" ></div>
		<div class="site-main-container">
			<div class="flow-checkout-container page-single-checkout-container container">
				<div class="comp-single-checkout-container ng-star-inserted">
					<div class="left-section-container">
						<div class="site-accordion">
							<div class="comp-group-heading-container done">
								<div class="steps">
									<div class="steps-count">
										<span class="accordion-item-indicator">1</span>
										<img src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle check-iocn"/>
									</div>
									<div class="steps-label">
										<div class="panel-label">
											<span class="accordion-item-title title-label">{{$t('common.customerinformation')}}</span>
											<!-- <span class="switch-link ng-star-inserted" v-if="isMobile">编辑</span> -->
										</div>
										<div class="panel-details ng-star-inserted" v-if="isMobile">
											<span class="customer-name">{{nickName}}，</span>
											<span class="customer-email">{{email}}</span>
										</div>
									</div>
								</div>
								<div class="active-container ng-star-inserted" v-if="!isMobile">
									<div class="panel-details ng-star-inserted">
										<span class="customer-name">{{nickName}}，</span>
										<span class="customer-email">{{email}}</span>
										<!-- <span class="switch-link ng-star-inserted">编辑</span> -->
									</div>
								</div>
							</div>
						</div>
						<div class="site-accordion ng-star-inserted" :class="step == 2 ? 'open' : ''">
							<div class="comp-group-heading-container shipping-nav" :class="step == 2 ? 'open' : (step > 2 ? 'done' : '')">
								<div class="steps">
									<div class="steps-count">
										<span class="accordion-item-indicator">2</span>
										<img src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle check-iocn"/>
									</div>
									<div class="steps-label">
										<div class="panel-label">
											<span class="accordion-item-title title-label">{{$t('cart.shippingaddress')}}</span>
											<span class="switch-link ng-star-inserted" v-if="isMobile && step > 2" @click="changeStep(2)">{{$t('common.view')}}</span>
										</div>
										<div class="panel-details ng-star-inserted" v-if="isMobile && step > 2">
											<span class="customer-name">{{memberAddress.address}}</span>
											<span class="customer-name">{{memberAddress.province}}，{{memberAddress.country}} {{memberAddress.postalcode}}</span>
										</div>
									</div>
								</div>
								<div class="active-container ng-star-inserted" v-if="!isMobile && step > 2">
									<div class="panel-details ng-star-inserted">
										<span class="customer-name">{{memberAddress.address}}</span>
										<span class="customer-name">{{memberAddress.province}}，{{memberAddress.country}} {{memberAddress.postalcode}}</span>
										<span class="switch-link ng-star-inserted" @click="changeStep(2)">{{$t('common.view')}}</span>
									</div>
								</div>
							</div>
							<div class="accordion-item-content-container shipping-form" v-if="step == 2">
								<div class="accordion-item-content ng-star-inserted">
									<span class="panel-header">{{$t('cart.shippingaddress')}}</span>
									<div class="comp-shipping-address-content-container">
										<div class="app-address-form">
											<div class="comp-address-form-container">
												<div class="shipping-address-form ng-untouched ng-pristine ng-invalid">
													<div class="company-column site-form-group form-group has-value">
														<label class="site-input-label">*{{$t('login.email')}}：</label>
														<input v-model="memberAddress.email" :placeholder="$t('tips.pleaseinputemail')" class="site-form-input form-control input-address ng-touched ng-dirty ng-invalid"/>
													</div>
													<div style="width: 100%;position: relative;overflow: hidden;">
														<div class="zip-code-column site-form-group form-group has-value">
															<label class="site-input-label">*{{$t('user.firstname')}}：</label>
															<input v-model="memberAddress.firstname" :placeholder="$t('tips.inputfirstname')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-invalid"/>
														</div>
														<div class="zip-code-column site-form-group form-group has-value" style="padding: 0 0 0 8px;">
															<label class="site-input-label">*{{$t('user.lastname')}}：</label>
															<input v-model="memberAddress.lastname" :placeholder="$t('tips.pleaseinputlastname')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-invalid"/>
														</div>
													</div>
													<div class="company-column site-form-group form-group has-value">
														<label class="site-input-label">{{$t('login.companyname')}}：</label>
														<input v-model="memberAddress.companyName" :placeholder="$t('tips.pleaseinputcompany')" class="site-form-input form-control input-address ng-touched ng-dirty ng-invalid"/>
													</div>
													<div class="state-column site-form-group form-group state-column-inner active">
														<label class="site-input-label">*{{$t('address.countryregion')}}：</label>
														<div class="site-input-group">
															<div class="site-dropdown dropdown" @click.stop="changeSelectExpand('countryExpandRef')">
																<button class="btn dropdown-toggle">
																	<span class="dropdown-toggle-label">{{memberAddress.country ? memberAddress.country : $t('tips.selectanoption')}}</span>
																	<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down ng-star-inserted down-icon"/>
																</button>
																<ul class="dropdown-menu" :class="openSelect && expandActive == 'countryExpandRef' ? 'ul-expand' : ''">
																	<li class="ng-star-inserted" v-for="(item,index) in countryData" :key="index">
																		<a href="javascript:void(0)" @click="selectExpand('countryCode','country',item)">
																			<span class="dropdown-link-text">{{item.title}}</span>
																			<img v-if="memberAddress.countryCode == item.id" src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle ng-star-inserted check-iocn"/>
																		</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<div style="width: 100%;position: relative;overflow: hidden;">
														<div class="zip-code-column site-form-group form-group has-value">
															<label class="site-input-label">*{{$t('address.streetaddress')}}：</label>
															<input v-model="memberAddress.address" :placeholder="$t('tips.pleaseinputstreetaddress')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-invalid"/>
														</div>
														<div class="zip-code-column site-form-group form-group has-value" style="padding: 0 0 0 8px;">
															<label class="site-input-label">{{$t('address.detailedaddress')}}：</label>
															<input v-model="memberAddress.remark" :placeholder="$t('tips.pleaseinputaptUnitSuite')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-invalid"/>
														</div>
													</div>
													<div class="company-column site-form-group form-group has-value">
														<label class="site-input-label">*{{$t('address.city')}}:</label>
														<input v-model="memberAddress.city" :placeholder="$t('tips.pleaseinputcity')" class="site-form-input form-control input-address ng-touched ng-dirty ng-invalid"/>
													</div>
													<div class="state-column site-form-group form-group state-column-inner active">
														<label class="site-input-label">*{{$t('address.provinceorregion')}}：</label>
														<div class="site-input-group">
															<div class="site-dropdown dropdown" @click.stop="changeSelectExpand('provinceExpandRef')">
																<button class="btn dropdown-toggle">
																	<span class="dropdown-toggle-label">{{memberAddress.province ? memberAddress.province : $t('tips.selectanoption')}}</span>
																	<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down ng-star-inserted down-icon"/>
																</button>
																<ul class="dropdown-menu" :class="openSelect && expandActive == 'provinceExpandRef' ? 'ul-expand' : ''">
																	<li class="ng-star-inserted" v-for="(item,index) in provinceData" :key="index">
																		<a href="javascript:void(0)" @click="selectExpand('provinceCode','province',item)">
																			<span class="dropdown-link-text">{{item.title}}</span>
																			<img v-if="memberAddress.provinceCode == item.id" src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle ng-star-inserted check-iocn"/>
																		</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<div style="width: 100%;position: relative;overflow: hidden;">
														<div class="zip-code-column site-form-group form-group has-value">
															<label class="site-input-label">*{{$t('address.zipcode')}}:</label>
															<input v-model="memberAddress.postalcode" type="text" :placeholder="$t('tips.pleaseinputzipcode')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
														</div>
														<div class="zip-code-column site-form-group form-group has-value" style="padding: 0 0 0 8px;">
															<label class="site-input-label">*{{$t('address.phone')}}:</label>
															<input v-model="memberAddress.phone" type="text" :placeholder="$t('tips.pleaseinptphone')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
														</div>
													</div>
													<!-- <div class="default-address-flag-container">
														<label class="site-custom-checkbox checkbox-label-wrapper">
															<input type="checkbox" class="checkbox-input"/>
															<span class="checkbox-icon-override"></span>
															<span class="checkbox-label">设置为我的首选地址</span>
														</label>
													</div> -->
													<div class="company-column site-form-group form-group">
														<textarea v-model="orderRemarks" :placeholder="$t('tips.inputorderremarks')" class="site-form-input site-form-textarea"></textarea>
													</div>
													<div class="col-md-22 check-coupon-wrapper">
														<span class="coupon-toggle-link" @click="changeCouponCollapsed">
															<span>{{$t('cart.havecoupon')}}</span>
															<img src="../../assets/images/arrow-down.png" class="down-icon"/>
														</span>
														<div class="site-panel coupon-section-panel" :class="useCoupon ? '' : 'hide-coupon-section'">
															<div class="comp-coupon-section-container">
																<div class="row">
																	<div class="col-md-15 col-xs-12">
																		<div class="coupon-input-group site-form-group">
																			<div class="site-input-group">
																				<input type="text" :placeholder="$t('tips.pleaseinputcoupon')"  maxlength="50" class="site-form-input name-input form-control">
																			</div>
																		</div>
																	</div>
																	<div class="col-md-9 col-xs-12">
																		<button class="site-btn-secondary apply-coupon-btn">
																			<span class="apply-coupon-label">{{$t('cart.usecoupon')}}</span>
																		</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="next-btn-container">
											<button @click="changeStep(3)" class="site-btn-primary save-address-btn checkout-next-btn" :class="isLoading ? 'site-btn-primary-disabled' : ''">
												<img src="../../assets/images/loading.png" class="loader-icon fa fa-spinner fa-spin ng-star-inserted loading-icon" v-if="isLoading"/>
												<span>{{$t('cart.continue')}}</span>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="site-accordion" :class="step == 3 ? 'open' : ''">
							<div class="comp-group-heading-container payment-method-nav" :class="step == 3 ? 'open' : ''">
								<div class="steps">
									<div class="steps-count">
										<span class="accordion-item-indicator">3</span>
										<img src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle check-iocn"/>
									</div>
									<div class="steps-label">
										<div class="panel-label">
											<span class="accordion-item-title title-label">{{$t('user.paymentmethod')}}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-item-content-container payment-options" v-if="step == 3">
								<div class="accordion-item-content ng-star-inserted">
									<span class="panel-header">{{$t('cart.choosepaymentmethod')}}</span>
									<div class="comp-payment-method-container">
										<div class="payment-options-container">
											<div class="payment-options-wrapper">
												<div class="ng-star-inserted">
													<div class="">
														<div class="comp-new-payment-profile-container active">
															<div class="payment-radio-group selected-payment-profile">
																<label class="site-custom-radio credit-card-label radio-label-wrapper">
																	<div class="option-radio-new-payment-info-container">
																		<input type="radio" checked class="option-radio-input"/>
																		<span class="radio-icon-override"></span>
																		<div class="new-payment-profile-label-group active">
																			<span class="new-payment-profile-label">{{$t('cart.enteranothercard')}}</span>
																			<span class="cc-icons">
																				<img src="../../assets/images/mastercard.svg"/>
																				<img src="../../assets/images/visa.svg"/>
																				<img src="../../assets/images/american-express.svg"/>
																				<img src="../../assets/images/discover.svg"/>
																			</span>
																		</div>
																	</div>
																</label>
																<div class="collapse in">
																	<div class="new-payment-profile-form">
																		<div>
																			<form id="payment-form" @submit.prevent="handleSubmit()">
																				<div class="payment-iframe wp-wrapper ng-star-inserted">

																					<!-- 1. 替换原卡号输入：Stripe Elements 支付容器 -->
																					<div id="payment-element" ref="paymentElementContainer"></div>
																				</div>
																				<div class="checkout-checkbox">
																					<label class="save-profile-checkbox site-custom-checkbox checkbox-label-wrapper same-as-shipping-enabled">
																						<input type="checkbox" id="save_profile" value="y" tabindex="-1">
																						<span class="checkbox-icon-override"></span>
																						<span class="checkbox-label">{{$t('cart.savepaymethod')}}</span>
																					</label>
																				</div>
																				<div class="next-btn-container">
																					<button type="submit" :disabled="isProcessing || !stripe || !elements || elementLoading"  class="site-btn-primary save-address-btn checkout-next-btn " :class="isLoading ? 'site-btn-primary-disabled' : ''">
																						<img src="../../assets/images/loading.png" class="loader-icon fa fa-spinner fa-spin ng-star-inserted loading-icon" v-if="isLoading"/>
																						<span>{{$t('cart.placeorder')}}</span>
																					</button>
																				</div>
																			</form>
																			<!-- <button class="checkout-btn checkout-btn-c" id="submitBtn" @click="openPage('order')">{{$t('cart.placeorder')}}</button> -->
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right-section-container">
						<div class="scroll-container">
							<div class="order-summary-container">
								<span class="order-summary-header-label">{{$t('cart.ordersummary')}}</span>
								<span class="order-summary-security-label">
									<img src="../../assets/images/locksafe.png" class="dri-lyons dri-secured-checkout secured-checkout-icon lock-safe-icon"/>
									{{$t('cart.securecheckout')}}
								</span>
								<div class="comp-order-summary-container">
									<ul class="site-list-group list-group order-summary-details-list" v-for="(item,index) in cartData" :key="index">
										<li class="price-group order-subtotal-details list-group-item">
											<div class="p-thumb-inner">
												<img :src="item.productImg"/>
											</div>
											<div class="p-product-infos-wrapper">
												<div class="p-name-block">
													<span>{{item.productName}}</span>
												</div>
												<div class="p-num-block">
													<span>x{{item.productNum}}</span>
												</div>
											</div>

											<!-- <div class="p-quantity-wrapper">
												<img src="../../assets/images/close.png" class="c-close-icon"/>
												<div class="p-quantity-block">
													<input type="button" value="-" class="minus btn">
													<input type="number" class="input-text qty text" value="1" min="0" step="1" inputmode="numeric" autocomplete="off">
													<input type="button" value="+" class="plus btn">
												</div>
												<div class="del-inner">
													<img src="../../assets/images/del.png" class="del-icon"/>
													<span class="item-action-label">{{$t('cart.delitem')}}</span>
												</div>
											</div> -->

										</li>
										<li class="price-group order-subtotal-details list-group-item" v-for="(sku,sIndex) in item.parsedSkuAttrs">
											<span class="price-label">{{sku.key}}</span>
											<span class="price-value">{{sku.value}}</span>
										</li>

									</ul>
									<ul class="site-list-group list-group">
										<li class="estimated-total-details list-group-item">
											<span class="price-label">{{$t('cart.tax')}}：   </span>
											<span class="price-value" v-if="lang == 'zh'">{{tax ? tax : 0}} 美元</span>
											<span class="price-value" v-else>${{tax}}</span>
										</li>
										<li class="estimated-total-details estimated-total-no-border list-group-item">
											<span class="price-label">{{$t('cart.shippingfee')}}：   </span>
											<span class="price-value" v-if="lang == 'zh'">{{deliveryfee ? deliveryfee : 0}} 美元</span>
											<span class="price-value" v-else>${{deliveryfee}}</span>
										</li>
										<li class="estimated-total-details estimated-total-no-border list-group-item">
											<span class="price-label">{{$t('cart.totalcost')}}：   </span>
											<span class="price-value" v-if="lang == 'zh'">{{totalPrice}} 美元</span>
											<span class="price-value" v-else>${{totalPrice}}</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<footers></footers>
		<!-- <loading v-if="isLoading"></loading> -->
	</div>
</template>

<script>
	import checkOutHeader from '../../components/checkOutHeader.vue'
	import footers from '../../components/footers.vue'
	import loading from '../../components/loading.vue'
	import {getStripe,confirmPayment} from '@/services/stripe';
	import {initConfirmOrder,queryRegion,createOrder,addAddress,editAddress,createPaymentntent,tocartcreatepaymentintent} from '../../api/api.js'
	export default {
		components: {
			checkOutHeader,
			footers,
			loading
		},
		data() {
			return {
        paymentIntentId: '',
				isMobile:false,
				openSelect:false,
				step:2,
				isLoading:false,
				cartData:[],
				totalPrice:10,
				memberAddress:{},
				lang:'',
				email:'',
				nickName:'',
				expandActive:'',
				countryCode:'',
				level:1,
				countryData:[],
				provinceData:[],
				orderRemarks:'',
				monthData:[
					{key:'1',title:this.$t('month.january')},
					{key:'2',title:this.$t('month.february')},
					{key:'3',title:this.$t('month.march')},
					{key:'4',title:this.$t('month.april')},
					{key:'5',title:this.$t('month.may')},
					{key:'6',title:this.$t('month.june')},
					{key:'7',title:this.$t('month.july')},
					{key:'8',title:this.$t('month.august')},
					{key:'9',title:this.$t('month.september')},
					{key:'10',title:this.$t('month.october')},
					{key:'11',title:this.$t('month.november')},
					{key:'12',title:this.$t('month.december')}
				],
				expMonth:'1',
				yearData:[],
				expYear:'',
				cardnumber:'',
				cvc:'',
				tax:0,
				addressFlag:0,//是否有账单地址1 有0 没有
				paytype:1,//支付类型 1 存储卡 2 第三方
				deliveryfee:0,
				orderInfos:{},
				clientSecret:null,
				isPay:false,
				stripe: null,
				elements: null,
				loadings: false,
				elementLoading: false,
				isProcessing: false,
				errorMessage: '',
				paymentElement: null,
				payNo:'',
				useCoupon:false
			};
		},
		mounted() {

		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			this.nickName = localStorage.getItem('nickname') || ''
			this.email = localStorage.getItem('email') || ''
			this.init()
			this.initPayment()
			this.queryRegion()
			var currentYear = new Date().getFullYear()
			this.expYear = currentYear % 100;
			this.yearData = this.generateYear(currentYear,currentYear+ 45)
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				initConfirmOrder(params).then(res => {
					if (res.code == 200) {
						that.cartData = res.data.cartAdvancedList
						that.totalPrice = res.data.totalPrice
						that.memberAddress = res.data.memberAddress
						that.tax = res.data.tax
						that.deliveryfee = res.data.deliveryfee
					}
				})
			},
			changeSelectExpand(element){
				if (this.expandActive == element) {
					this.openSelect = false
					this.expandActive = ''
				}else{
					this.expandActive = element
					this.openSelect = true
				}
			},
			closeSelectExpand(){
				this.openSelect = false
			},
			selectExpand(e,ename,val){
				this.memberAddress[e] = val.id
				this.memberAddress[ename] = val.title
				if(e == 'countryCode'){
					this.countryCode = val.regionid
					this.memberAddress.provinceCode = ''
					this.memberAddress.province = ''
					this.level = 2
					this.queryRegion()
				}
			},
			changeStep(e){
				if(this.verification() || this.step > e){
					if(this.step == 2){
						this.submitAddress()
					}else{
						this.step = e
						this.scrollToTop()
					}
				}
			},
			queryRegion(){
				var that = this;
				let params = {
					pid:this.countryCode,
					level:this.level
				}
				queryRegion(params).then(res => {
					if (res.code == 200) {
						if(that.level == 1){
							that.countryData = res.data
						}else{
							that.provinceData = res.data
						}
					}
				})
			},
			verification() {
				if(this.step == 2){
					if(!this.memberAddress.email){
						this.$message.warning(this.$t('tips.pleaseinputemail'));
						return false;
					}
					if(!this.memberAddress.firstname){
						this.$message.warning(this.$t('tips.pleaseinputfirstname'));
						return false;
					}
					if(!this.memberAddress.lastname){
						this.$message.warning(this.$t('tips.pleaseinputlastname'));
						return false;
					}
					if(!this.memberAddress.countryCode){
						this.$message.warning(this.$t('tips.pleaseinputcountryregion'));
						return false;
					}
					if(!this.memberAddress.address){
						this.$message.warning(this.$t('tips.pleaseinputstreetaddress'));
						return false;
					}
					if(!this.memberAddress.city){
						this.$message.warning(this.$t('tips.pleaseinputcity'));
						return false;
					}
					if(!this.memberAddress.provinceCode){
						this.$message.warning(this.$t('tips.pleaseinputprovinceorregion'));
						return false;
					}
					if(!this.memberAddress.postalcode){
						this.$message.warning(this.$t('tips.pleaseinputzipcode'));
						return false;
					}
					if(!this.memberAddress.phone){
						this.$message.warning(this.$t('tips.pleaseinptphone'));
						return false;
					}
				}
				if(this.step == 3){
					// if(!this.cardnumber){
					// 	this.$message.warning(this.$t('tips.pleaseinputcardno'));
					// 	return false;
					// }
					// if(!this.cvc){
					// 	this.$message.warning(this.$t('tips.pleaseinputcvc'));
					// 	return false;
					// }
					// if(!this.memberAddress.id){
					// 	this.$message.warning(this.$t('tips.addressnotempty'));
					// 	return false;
					// }
				}
				return true;
			},
			submitAddress(){
				if(this.memberAddress.id){
					this.confirmEditAddress()
				}else{
					this.confirmAddAddress()
				}
			},
			confirmAddAddress(){
				var that = this;
				let params = {
					type:2,
					email:this.memberAddress.email,
					firstname:this.memberAddress.firstname,
					lastname:this.memberAddress.lastname,
					companyName:this.memberAddress.companyName,
					country:this.memberAddress.country,
					city:this.memberAddress.city,
					postalcode:this.memberAddress.postalcode,
					province:this.memberAddress.province,
					phone:this.memberAddress.phone,
					address:this.memberAddress.address,
					remark:this.memberAddress.remark,
					provinceCode:this.memberAddress.provinceCode,
					countryCode:this.memberAddress.countryCode,
				}
				that.isLoading = true
				addAddress(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.init()
						that.step = 3
						that.scrollToTop()
						that.$nextTick(()=>{
							that.initializeStripe();
						})

					}else{
						that.$message.warning(res.msg);
						return false;
					}

				})
			},
			confirmEditAddress(){
				var that = this;
				let params = {
					type:2,
					email:this.memberAddress.email,
					firstname:this.memberAddress.firstname,
					lastname:this.memberAddress.lastname,
					companyName:this.memberAddress.companyName,
					country:this.memberAddress.country,
					city:this.memberAddress.city,
					postalcode:this.memberAddress.postalcode,
					province:this.memberAddress.province,
					phone:this.memberAddress.phone,
					address:this.memberAddress.address,
					remark:this.memberAddress.remark,
					provinceCode:this.memberAddress.provinceCode,
					countryCode:this.memberAddress.countryCode,
					id:this.memberAddress.id
				}
				that.isLoading = true
				editAddress(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.init()
						that.step = 3
						that.scrollToTop()
						that.$nextTick(()=>{
							that.initializeStripe();
						})
					}else{
						that.$message.warning(res.msg);
						return false;
					}

				})
			},
			toConfirm(){
				if(this.verification()){
					var that = this;
					var cartJson = []
					if(this.cartData.length > 0){
						this.cartData.forEach(item => {
							cartJson.push({
								cartId:item.id,
								productNum:item.productNum,
								designdraft:item.fileurl
							})
						});
					}
					let params = {
            payorderno:this.payorderno,
            paymentIntentId:this.paymentIntentId,
						cardNo:this.cardnumber,
						paytype:this.paytype,
						validityperiod:this.expMonth+'/'+this.expYear,
						safetycode:this.cvc,
						deliveryfee:this.deliveryfee,
						tax:this.tax,
						cartjson:cartJson
					}
					createOrder(params).then(res => {
						if (res.code == 200) {
							that.orderInfos = res.data
							that.handlePay()
							return true;
						}else{
							that.$message.warning(res.msg);
							return false;
						}

					})
				}
			},
			formatCardNumber() {
			    // 移除非数字字符
			    let numbers = this.cardnumber.replace(/\D/g, '');
			    // 根据卡类型格式化
			    // 标准格式: XXXX XXXX XXXX XXXX
			    let formatted = '';
			    for (let i = 0; i < numbers.length; i++) {
			        if (i > 0 && i % 4 === 0) {
			            formatted += ' ';
			        }
			        formatted += numbers[i];
			    }
			    numbers = formatted;
			    this.cardnumber = numbers;
			},
			createPaymentntent(){
				var that = this;
				let params = {
					orderId:this.orderInfos.id
				}
				createPaymentntent(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.clientSecret = res.data.clientSecret
						that.isPay = true
						that.initializeStripe();
						//that.openPage('/order')
					}else{
						that.$message.warning(res.msg);
						return false;
					}

				})
			},
			initPayment(){
				var that = this;
				let params = {}
				tocartcreatepaymentintent(params).then(res => {
					that.isLoading = false
					if (res.code == 200) {
						that.clientSecret = res.data.clientSecret
            that.payorderno=res.data.payorderno
            that.paymentIntentId=res.data.paymentIntentId
						//that.openPage('/order')
					}else{
						that.$message.warning(res.msg);
						return false;
					}

				})
			},
			async initializeStripe() {
				try {
					this.loading = true;
					this.errorMessage = '';

					// 检查容器元素是否存在
					if (!this.$refs.paymentElementContainer) {
						throw new Error('Payment element container not found');
					}

					// 初始化 Stripe
					this.stripe = await getStripe();
					// 创建 Elements
					this.elements = this.stripe.elements({
						clientSecret: this.clientSecret,
						appearance: {
							theme: 'stripe',
							variables: {
								colorPrimary: '#0570de',
								colorBackground: '#ffffff',
								colorText: '#30313d',
								colorDanger: '#df1b41',
								fontFamily: 'Ideal Sans, system-ui, sans-serif',
								spacingUnit: '2px',
								borderRadius: '4px',
							}
						}
					});

					// 创建 Payment Element
					this.paymentElement = this.elements.create('payment', {
						layout: {
							type: 'tabs',
							defaultCollapsed: false
						}
					});

					// 等待元素加载完成
					this.elementLoading = true;

					// 挂载到 DOM - 确保容器元素存在
					await this.paymentElement.mount(this.$refs.paymentElementContainer);

					this.elementLoading = false;

					// 监听元素就绪事件
					this.paymentElement.on('ready', () => {
						// console.log('Payment Element is ready');
						this.elementLoading = false;
					});

					// 监听变化事件
					this.paymentElement.on('change', (event) => {
						if (event.error) {
							this.errorMessage = event.error.message;
							this.$message.error(this.errorMessage);
						} else {
							this.errorMessage = '';
						}
					});

				} catch (error) {
					// console.error('Stripe initialization error:', error);
					this.errorMessage = this.$t('order.payinterror');
					this.$message.error(this.errorMessage);
					this.elementLoading = false;
				} finally {
					this.loading = false;
				}
			},

			async handleSubmit() {
				if(!this.isLoading){
					try {
						this.isProcessing = true;
						this.errorMessage = '';
						this.isLoading = true;

						// 检查必要的依赖
						if (!this.stripe || !this.elements) {
							this.isLoading = false
						    throw new Error('Payment system not properly initialized');
						}

						// 第一步：立即调用 elements.submit()
						const { error: submitError } = await this.elements.submit();
						if (submitError) {
							this.isLoading = false
						    throw submitError;
						}
						this.toConfirm()
					} catch (error) {
						//console.error('Payment error:', error);
						this.isLoading = false
						if (error.type === 'card_error' || error.type === 'validation_error') {
							this.errorMessage = error.message;
						} else {
							this.errorMessage = this.$t('order.payerror');
						}
						this.$message.error(this.errorMessage);
						this.openPage('/order')
					} finally {
						this.isProcessing = false;
						this.isLoading = false
					}
				}

			},
			async handlePay() {
				try {
					// 第二步：确认支付
					const { error: confirmError } = await this.stripe.confirmPayment({
					    elements: this.elements,
					    clientSecret: this.clientSecret,
					    confirmParams: {
					        return_url: `${window.location.origin}/payment-success`,
					        // 可以传递额外的参数
					        payment_method_data: {
					            billing_details: {
									// orderNo: this.orderInfos.orderNo,
									email: this.memberAddress.email,
									// 其他账单信息...
					            }
					        }
					    },
					    redirect: 'if_required',
					});

					if (confirmError) {
						this.isLoading = false
					    throw confirmError;
					}
					this.isLoading = false

					this.$router.push({
					  name: 'payment-success',
					  params: {
					    amount: this.totalPrice,
						orderData:this.orderInfos,
					    timestamp: new Date().toISOString(),
					  }
					})
				} catch (error) {
					console.error('Payment error:', error);

					if (error.type === 'card_error' || error.type === 'validation_error') {
						this.errorMessage = error.message;
					} else {
						this.errorMessage = this.$t('order.payerror');
					}
					this.$message.error(this.errorMessage);
					setTimeout(() => {
						this.openPage('/order')
					}, 1000)

				} finally {
					this.isProcessing = false;
				}

			},
			changeCouponCollapsed(){
				this.useCoupon = !this.useCoupon
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/checkout.css");
	.global-header-spacer {
	    height: 60px !important;
	    display: block !important;
	}
</style>
